/* eslint-disable no-whitespace-before-property */
import React, {Fragment} from "react";
import {Affiliate, User, PlayerListRequest, PlayerListResponse} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {RouteComponentProps, withRouter} from "react-router";
import {LoadingViewState, RouterView} from "../RouterView";
import {formatDate} from "../../util/date";
import {Link} from "react-router-dom";
import {AffiliatesService} from "../../services/AffiliatesService";
import {LoadingSpinner} from "../../util/LoadingSpinner";
import {MetricHighChart} from "../metrics/MetricHighChart";
import { PagerModel } from "../list/list/PagerModel";
import { ActionType } from "../list/list/DataTable";
import { EntityDataTable } from "../list/list/EntityDataTable";
import { ListUtils } from "../list/list/ListUtils";
import {AdminNotes} from "../notes/AdminNotes";

interface State extends LoadingViewState {
    affiliate? : Affiliate;
    revenue? : any;
    playersListRequest : PlayerListRequest;
    playerListDetails : PlayerListResponse;
    loading: boolean;
}

interface Props extends RouteComponentProps {

}

export class AffiliateView extends RouterView<Props,State> {

    service : AffiliatesService;
    
    constructor(props : Props){
        super(props);
        this.service = getContainer().getAffiliatesService();
        this.state = { 
            affiliate : {}, 
            revenue : {}, 
            playersListRequest: {"offset":0,"limit":100,"ascending":false, "orderBy": "created"},
            playerListDetails : {}, 
            loading : true
        };
    }

    loadContent() : Promise<any> | undefined {
        let id = (this.props.match.params as any).id;
        let date = new Date();
        let yearMonth = new Date(date.getFullYear(), date.getUTCMonth(), 2).toISOString().slice(0, 7);
        console.log("yearMonth: ", yearMonth);
        return this.service.getEntity(id).then((a : User) => {
            a.id && this.service.getAffiliateRevenue(yearMonth,a.id). then((data) => {
                console.log(data);
                this.setState({ affiliate : a, revenue: [data]});
            }).catch((e)=>{
                this.setState({ affiliate : a});
                console.log("failed to get affiliate revenue`: ",e );
            });
        });

    }

    loadPlayers(request: PlayerListRequest){
        let id = (this.props.match.params as any).id;
        return this.service.getAffiliatePlayersAll(id, request)
    }

    pagerChanged(pager : PagerModel) {
        if(!this.state.playersListRequest){
            return;
        }
        let listRequest = ListUtils.toListRequest<any>(this.state.playersListRequest,pager);
        this.setState({playersListRequest : listRequest});
    }

    componentDidUpdate(prevProps : RouteComponentProps, prevState : any) {
        if((this.props.match.params as any).id !== (prevProps.match.params as any).id) {
            this.refreshContent();
        } else {
            super.componentDidUpdate(prevProps, prevState);
        }
    }

    getAffiliateInfo() {
        if(!this.state.affiliate) {
            return <LoadingSpinner/>
        }
        return (
            <div className={"row"}>
                <div className="col-lg-6">
                    <div className={"card-box"}>
                        <Link to={"edit/" + this.state.affiliate.id} className={"btn btn-warning"} style={{float : "right"}}><i className={"fe-edit"}></i> Edit User</Link>
                        <h4>{this.state.affiliate.email}</h4>
                        <h5>User Id: {this.state.affiliate.id}</h5>
                        <table className={"table table-striped"}>
                            <tbody>
                            <tr>
                                <td>Enabled</td>
                                <td>{this.state.affiliate.enabled ? <span className={"green"}>Yes</span> : <span className={"red"}>No</span>} </td>
                            </tr>
                            <tr>
                                <td>Created</td>
                                <td>{formatDate(this.state.affiliate.created)}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>{this.state.affiliate.status}</td>
                            </tr>
                            <tr>
                                <td>Auto Pay Enabled</td>
                                <td>{this.state.affiliate.autoPayEnabled ? <span className={"green"}>Yes</span> : <span className={"red"}>No</span>} </td>
                            </tr>
                            <tr>
                                <td>Negative Carryover Enabled</td>
                                <td>{this.state.affiliate.negativeCarryoverEnabled ? <span className={"green"}>Yes</span> : <span className={"red"}>No</span>} </td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>{this.state.affiliate.email}</td>
                            </tr>
                            <tr>
                                <td>Name</td>
                                <td>{this.state.affiliate.name}</td>
                            </tr>
                            <tr>
                                <td>Username</td>
                                <td>{this.state.affiliate.username}</td>
                            </tr>
                            <tr>
                                <td>Cashout ID</td>
                                <td>{this.state.affiliate.cashoutUserId}</td>
                            </tr>
                            <tr>
                                <td>Cashout Username</td>
                                <td>{this.state.affiliate.cashoutUsername}</td>
                            </tr>
                            <tr>
                                <td>Cashout UpdateTime</td>
                                <td>{formatDate(this.state.affiliate.cashoutUpdateTime)}</td>
                            </tr>
                            <tr>
                                <td>Default Revenue Share</td>
                                <td>{this.state.affiliate.defaultRevenueShare}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-lg-6">
                    <AdminNotes type={"AFFILIATE"} typeId={""+this.state.affiliate.id} title={"Affiliate Notes"}/>
                </div>
            </div>
        )
    }

    getPlayersList() {
        
        let columns = [
            { property : "id", name : "ID"},
            { property : "playerId", name : "Account ID"},
            { property : "username", name : "Username"},
            { property : "status", name : "Status"},
            { property : "synchAttempts", name : " Synch Attempts"},
            { property : "provider", name : "Provider"},
            { property : "externalId", name : "External Id"},
            { property : "created", name : "Date Created"}
        ];

        let actions = [
            { id : "view", name : "View", className : "btn btn-primary", iconClassName : "fa fa-user", type : ActionType.LINK, getLink : (item : any) => "/user/" + item.playerId },
    
        ];

        return (
            <div className="row">
                <div className="col-lg-6">
                    <EntityDataTable
                        listRequest={this.state.playersListRequest}
                        columns={columns}
                        onPagerChange={this.pagerChanged.bind(this)}
                        actions={actions}
                        title="Players"
                        customRequest={this.loadPlayers.bind(this)}
                        setMaxLimit={100}
                    />
                </div>
            </div>
        )
    }

    getTitle() : string {
        return "Affiliate Overview";
    }

    renderContent() {
        if(!this.state.affiliate) {
            return <LoadingSpinner />
        }
        return (

            <Fragment>
                <div className="row">
                    <div className={"col-lg-12"}>
                        <MetricHighChart data={this.state.revenue} header={"Monthly Revenue"} />
                        {this.getAffiliateInfo()}
                        {this.getPlayersList()}
                    </div>
                </div>
            </Fragment>
        )
    }

}

export default withRouter(AffiliateView);
